import React from "react";
import { ResultItemList, Paginator } from '.';

class PaginatedResults extends React.Component{
    constructor(props) {
        super(props);

        let totalPages = props.Items && props.Items.length / props.resultsPerPage;
        if(props.Items && (props.Items.length % props.resultsPerPage > 0)){
            totalPages++;
        }

        this.state = {
            resultsPerPage: props.resultsPerPage,
            selectedPage: 1,
            totalItems: props.Items,
            itemsToDisplay: props.Items && props.Items.filter((e, i) => i < props.resultsPerPage),
            totalPages: Math.floor(totalPages),
            handlePageChange: props.handlePageChange
        };

        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {
        $('[data-toggle="popover"]').popover({
            trigger: "hover"
        });
    }

    handlePageChange(selectedPage){
        const {totalItems, handlePageChange} = this.state;

        this.setState({
            ...this.state, 
            selectedPage: selectedPage,
            itemsToDisplay: totalItems && totalItems.filter((e, i) => i >= ((selectedPage-1)*this.state.resultsPerPage) && i < this.state.resultsPerPage*selectedPage),
        });
        handlePageChange && handlePageChange(selectedPage);
    }

    render(){
        const {itemsToDisplay, totalItems, resultsPerPage, selectedPage, totalPages} = this.state;
        return (
            <div>
                {
                    itemsToDisplay &&
                    itemsToDisplay.length > 0 &&
                    <ResultItemList Items={itemsToDisplay}></ResultItemList>
                }
                {
                    totalItems &&
                    totalItems.length > resultsPerPage &&
                    <Paginator currentPage={selectedPage} totalPages={totalPages} 
                    handlePageChange={this.handlePageChange} visibleElementsOnBothSide={2}></Paginator>
                }
            </div>
        );
    }
}

export default PaginatedResults;